import { GaEvent } from "../../../services/ga.service";

export const testPhoneNumber = (value: any) => {
  let reg =  /^[6-9]\d{9}$/gi;;
  return reg.test(value);
};

export const testEmail = (value: any) => {
  let reg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(value);
};

export const fetchGaEventDetails =(eventName,categoryName,username,maid)=>{
  GaEvent(eventName, {
    category: categoryName,
    label: `${username??""}`+'_'+`${maid??""}`,
    userProperty:
        JSON.stringify({
          Maid:maid??"",
          Username: username??"",
        })
})
}

export const GaEventForMoreDetails =(eventName,categoryName,username,UserDetails)=>{
  GaEvent(eventName, {
    category: categoryName,
    label: `${username??""}`+'_'+`${UserDetails?.benefId??""}`+'_'+`${UserDetails?.primeBenefName??""}`,
    userProperty:
        JSON.stringify({
          benefId:UserDetails?.benefId??"",
          Username: username??"",
          primeBenefName: UserDetails?.primeBenefName??"",
          polHolderName: UserDetails?.polHolderName??"",          
        })
})
}
